import { useOrganizationUser } from "src/api/taktile/queries";
import { Pill } from "src/base-components/Pill";
import { AuthorPageParams } from "src/router/urls";
import { useParamsDecode } from "src/utils/useParamsDecode";

type EditorLockProps = {
  lockOwner: string;
};

export const EditorLock: React.FC<EditorLockProps> = ({ lockOwner }) => {
  const { orgId } = useParamsDecode<AuthorPageParams>();
  const editingUser = useOrganizationUser(orgId, lockOwner);

  return (
    <Pill fontType="text" variant="gray" maxWidth>
      {editingUser.isLoading ? (
        <Pill.Avatar isLoading />
      ) : (
        <Pill.Avatar user={editingUser.data ?? {}} />
      )}
      <Pill.Text>{`${editingUser.data?.full_name} is editing...`}</Pill.Text>
    </Pill>
  );
};
